import React, { useEffect, useCallback, useState} from 'react';
import GroupTracker from './GroupTracker.js';
import {moveTrackToGroup} from './moveTrackToGroup.js';
import GroupVolumeControl from './GroupVolumeControl.js';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';
import Track from './Track.js';
import {setSelectedGroup} from 'actions/index.js';

const colors = new Colors();

const Group = ({
    group,
    isCollapsed,
    setSelectedGroup,
    isSelectedGroup,
    trackDragging,
    groupTracks
}) => {
    let tracks = group.tracks;
    let groupClassName = "group-container";
    const color = colors.getColorForTrack(group.tracks[0]);
    let style = {
        backgroundColor: color,
    };

    let fullStyle = {};

    if (isSelectedGroup) {
        groupClassName += " selected";
        fullStyle.boxShadow = "0px 0px 2px 2px " + color;
    }

    const onDrop = useCallback((e) => {
        e.stopPropagation();
        if (trackDragging) {
            moveTrackToGroup(trackDragging, group);
        }
    }, [trackDragging, group]);

    const onMouseDown = useCallback(() => {
        setSelectedGroup(group.groupNumber);
    }, [group, setSelectedGroup]);

    return (
        <div
          onDrop={onDrop}
          onMouseDown={onMouseDown}
          style={fullStyle}
          className={groupClassName}>
          <div style={style} className="group-top"></div>
          <div className="group-inner">
            <GroupVolumeControl group={group}/>
            <div className="tracks-and-tracker">
              <div className="group-tracks">
                {isCollapsed ?
                "" : 
                 tracks.map(track => <Track track={track}/>)}
              </div>
            </div>
          </div>
        </div>);
    // { isCollapsed ? "" : <GroupTracker group={group}/>}
}

const mapStateToProps = (state, props) => {
  return {
      isCollapsed: state.mix.groupCollapsed[props.group.subSequence.id] &&
          state.mix.groupCollapsed[props.group.subSequence.id][props.group.groupNumber],
      isSelectedGroup: state.mix.selectedGroup === props.group.groupNumber,
      trackDragging: state.mix.trackDragging,
      groupTracks: state.tracks.groupTracks[props.group.id],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedGroup: (g) => dispatch(setSelectedGroup(g))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Group);
